module.exports = __webpack_public_path__ + "img/sld_connector.4e42e1b9.svg";